import {
    GET_BILLING_SUBSCRIPTIONS_START,
    GET_BILLING_SUBSCRIPTIONS_END,
    GET_BILLING_SUBSCRIPTIONS_SUCCESS,
    GET_BILLING_SUBSCRIPTIONS_ERROR
} from "../../../../actions/metering/billing/subscriptions";

const defaultBillingState = {
    status: { loading: false, error: null },
    data: []
};

export const subscriptionsReducer = (state = defaultBillingState, { type, payload }) => {
    switch (type) {
        case GET_BILLING_SUBSCRIPTIONS_START: {
            return {
                ...state,
                status: { ...state.status, loading: true }
            };
        }
        case GET_BILLING_SUBSCRIPTIONS_END: {
            return {
                ...state,
                status: { ...state.status, loading: false }
            };
        }
        case GET_BILLING_SUBSCRIPTIONS_SUCCESS: {
            const { subscriptions } = payload;
            return {
                ...state,
                data: subscriptions
            };
        }
        case GET_BILLING_SUBSCRIPTIONS_ERROR: {
            const { error } = payload;
            return {
                ...state,
                status: { ...state.status, error }
            };
        }
        default: {
            return state;
        }
    }
};
